import script from "./BrowseAndPublicationCompo.vue?vue&type=script&setup=true&lang=js"
export * from "./BrowseAndPublicationCompo.vue?vue&type=script&setup=true&lang=js"

import "./BrowseAndPublicationCompo.vue?vue&type=style&index=0&id=61e184a7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-61e184a7"]])

export default __exports__